"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _appShellApis = require("@icis/app-shell-apis");
var _components = require("./components");
var _analyticsNamings = require("./constants/analyticsNamings");
var _RequestToolModal = require("./RequestToolModal.styles");
var _mutation = require("../../apollo/mutation");
var _getAppConfig = _interopRequireDefault(require("../../constants/getAppConfig"));
var _hooks = require("../../hooks");
var _l10n = require("../../l10n");
const ModalViews = {
  notify: _components.Notify,
  success: _components.Success,
  error: _components.Error
};
const ModalData = {
  notify: {
    headerTitle: 'RequestTool.unlockData',
    footerTitle: 'RequestTool.requestAccess',
    modalType: 'notify'
  },
  success: {
    headerTitle: 'RequestTool.requestSent',
    footerTitle: 'RequestTool.done',
    modalType: 'success'
  },
  error: {
    headerTitle: 'RequestTool.requestFailed',
    footerTitle: 'RequestTool.done',
    modalType: 'error'
  }
};
const getModalData = getTranslation => key => {
  const data = ModalData[key];
  return {
    headerTitle: getTranslation(data.headerTitle),
    footerTitle: getTranslation(data.footerTitle),
    modalType: data.modalType
  };
};
const RequestToolModal = _ref => {
  let {
    onDismiss,
    saleForceCode,
    productInterest,
    afterSubmit,
    ModalComp
  } = _ref;
  const locale = (0, _hooks.useLocale)();
  const [open, setIsOpen] = (0, _react.useState)(true);
  const getMessageFromKey = (0, _l10n.getMessages)(locale);
  const translatedModalData = getModalData(getMessageFromKey);
  const [modalData, setModalData] = _react.default.useState({
    ...translatedModalData('notify')
  });
  const {
    action
  } = (0, _mutation.useRequestSubscriptionMutation)();
  (0, _react.useEffect)(() => {
    const sendTrackPageView = (modalType, salesForceCode) => {
      const names = _analyticsNamings.namings[modalType];
      const pageName = "subscriber|website|".concat(names.name, "|").concat(salesForceCode, " - ").concat(names.alternate);
      const trackPageViewData = {
        gwa_account: (0, _getAppConfig.default)().analytics.account,
        gwa_siteSection3: names.name,
        gwa_contentTitle: "".concat(salesForceCode, " - ").concat(names.alternate),
        gwa_pageName: pageName,
        gwa_contentHierarchy: pageName,
        gwa_localVar22: locale === 'zh' ? 'mandarin language' : 'english language'
      };
      (0, _appShellApis.trackPageView)(trackPageViewData);
    };
    if (open) {
      sendTrackPageView(modalData.modalType, saleForceCode);
    }
  }, [open, saleForceCode, modalData.modalType, locale]);
  const onSubmitModal = async () => {
    setIsOpen(false);
    if (modalData.modalType === 'notify') {
      try {
        await action({
          items: [saleForceCode],
          source: "".concat(_analyticsNamings.OPPORTUNITY_TYPE_VALUE, ":NULL:NULL:").concat(_analyticsNamings.JOURNEY_VALUE, ":").concat(saleForceCode, ":NULL:").concat(window.location.href),
          productInterest
        });
        setModalData({
          ...translatedModalData('success')
        });
      } catch {
        setModalData({
          ...translatedModalData('error')
        });
      }
      setIsOpen(true);
    } else {
      afterSubmit();
    }
  };
  const ModalChild = ModalViews[modalData.modalType];
  if (!open) return null;

  // The styling is for not to show the pilet extension loading icon
  return /*#__PURE__*/_react.default.createElement(_RequestToolModal.ModalContainer, null, /*#__PURE__*/_react.default.createElement(ModalComp, {
    testId: "request-tool--modal",
    onDismiss: onDismiss,
    onSubmit: onSubmitModal,
    ariaLabel: "sh-analytics--modal",
    version: "V2",
    isOpen: true,
    header: {
      visible: true,
      title: modalData.headerTitle,
      style: {
        fontSize: 'bold'
      }
    },
    footer: {
      visible: true,
      title: modalData.footerTitle
    },
    variant: "Small",
    isMobileView: true
  }, /*#__PURE__*/_react.default.createElement(ModalChild, {
    code: saleForceCode
  })));
};
var _default = exports.default = RequestToolModal;